import React, { Fragment } from "react";

const UserItem = ({ user, deleteUser }) => {
  return (
    <Fragment>
      <div className="user-section-alt">
        <div className="setting-user-container">
          <div className="setting-friend-user-avi-container">
            <div
              className={`avi-color-border ${
                user && user.role === "innovator"
                  ? "green"
                  : user && user.role === "mentor"
                  ? "red"
                  : user && user.role === "employer"
                  ? "blue"
                  : ""
              }`}
            >
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                className="friend-user-avi"
                alt="avi"
              />
            </div>
          </div>
          <div className="friend-user-info">
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span
                    className={`${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    } name-font`}
                  >
                    {user.channelid}
                  </span>
                </li>
                <li className="user-online-item">
                  {user.firstname} {user.lastname}
                </li>
                <li className="user-online-item">{user.jobtitle}</li>
                <li className="user-online-item">
                  {user.location && user.location.state},{" "}
                  {user.location && user.location.country}
                </li>
              </ul>
            </div>
          </div>
        </div>
        {user.channelid !== "roland" && (
          <div className="setting-friends-buttons-container">
            <div className="friend-button-container">
              <button
                onClick={() => deleteUser(user.channelid)}
                className={`setting-friend-button ${
                  user && user.role === "innovator"
                    ? "background-green"
                    : user && user.role === "mentor"
                    ? "background-red"
                    : user && user.role === "employer"
                    ? "background-blue"
                    : ""
                }`}
              >
                <i className="fa-solid fa-times mx-5"></i>
                Delete
              </button>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default UserItem;
